import { useEffect, useState } from "react";
import { motion, useScroll, useSpring } from "framer-motion";
import { ArrowUp } from "lucide-react";

export function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 26, mass: 0.3 });
  return (
    <motion.div
      className="fixed top-0 left-0 right-0 h-[3px] z-[90] origin-left"
      style={{
        scaleX,
        background: "linear-gradient(90deg, #8DB9E8, #D9E0E8, #B9D2ED)",
        boxShadow: "0 0 12px rgba(141,185,232,0.6)",
      }}
      aria-hidden="true"
      data-testid="scroll-progress"
    />
  );
}

export function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="Back to top"
      className={`fixed bottom-24 right-5 z-[80] w-11 h-11 rounded-full bg-dt-card border border-dt-border text-dt-accent flex items-center justify-center shadow-lg transition-all duration-300 hover:border-dt-accent hover:scale-110 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"}`}
      data-testid="back-to-top"
    >
      <ArrowUp className="w-4 h-4" />
    </button>
  );
}
